/**
 * created by xcc
 * 用户管理   sys  添加用户
 */

import React, {Component} from 'react';
import {Radio, message, Input, TreeSelect, Modal, Row, Col, Icon, Tree, Checkbox, Tag, Table, Pagination} from "antd";
import PropTypes from "prop-types";
import * as Action from '../../../actions/UserManagementSys';
import {Scrollbars} from "react-custom-scrollbars";

const {SHOW_PARENT} = TreeSelect;


class AddUser extends Component {
    static defaultProps = {
        newSecondSelectColor: "#0050B3"
    }
    static propTypes = {
        title: PropTypes.string.isRequired,
        visible: PropTypes.bool.isRequired,
        currentLeftMenuList: PropTypes.array.isRequired,
        deptTreeData: PropTypes.array.isRequired,
        allMedia: PropTypes.array,
        addUserProps: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            accountValue: "",//账号
            officePhoneValue: "",//办公电话
            phoneValue: "",//手机
            propertyValue: "",//属性
            sexValue: 1,//性别
            roleValue: 2, //角色
            nameValue: "", //姓名
            departmentValue: "",//部门
            typeKey: [],  //TreeSelect中的value
            departVisible: false,
            checkedKeys: [],  //部门Tree选中的节点
            contributeRoleList: [],  //投稿端角色列表
            manageRoleList: [],  //管理端角色列表
            itemChildren: [],//其它角色列表
            contributeRoleLists: [],  //treeData中展示的投稿端角色列表
            manageRoleLists: [],   //treeData中展示的管理端角色列表
            mediaRoles: [],  //options中展示的媒体角色
            mediaCodesArray: [],//合并的媒体codes
            mediaRoleValue: [],  //媒体角色value
            allMediaRoles: [], //所有媒体角色
            mediaCodesData: [],  //媒体的options展示的数据
            itemRoleCode: [],  //treeSelect中当前条数据中的roleCode
            itemParentRoleCodes: [],
            roleList: [],

            //网站管理员列表
            managerType: [],  //根据type筛选的绑定管理员列表
            managerStart: 1,
            managerSize: 10,
            websiteManagerVisible: false,
            managerList: [],  //管理员列表
            listTotal: "",  //列表总数
            menuInitialData: [], //菜单初始数据
            currentMediaCode: [],  //当前媒体角色code
            roleCodes: [],
            roleSons: [],
            checkedKey: [],
            managerItemId: "",//管理员id
            managerItemName: "",  //绑定媒体名称
            itemIndex: "",  //选中
            managerCheckedAccount: "", //选中账号
            deptTreeData: [],  //部门数据
            isDisabled: false,
            isHidden: false,
            websiteMediaIds: [],
            selectedRecord: {}
        };
    }

    componentDidMount() {
        this.getRole();   //页面加载时显示的是管理端角色
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log("子组件更新");
        this.state.deptTreeData = nextProps.deptTreeData;
        if (nextProps.id !== this.props.id) {
            let roleShow = [];
            let otherRole = [];
            let otherRoleShow = [];
            let roleType = "";
            nextProps.addUserProps.allRole.forEach(item => {
                if (item.roleType === 1 || item.roleType === 2) {
                    roleType = item.roleType;
                    roleShow.push(item.id);
                    this.getRole();
                }
                nextProps.addUserProps.allRole.forEach(i => {
                    if (i.parentRoleCodes.includes(item.roleCode)) {
                        otherRole.push({title: i.roleName, value: i.id, key: i.id})
                        otherRoleShow.push(i.id)
                    }
                })
            })
            if (nextProps.addUserProps.mediaRoleCodes) {
                this.getMedia(nextProps.addUserProps.mediaCodes)
            }
            if (nextProps.addUserProps.mediaRoleCodes.length > 0) {
                this.getMediaRole();
            }
            this.setState({
                accountValue: nextProps.addUserProps.accountValue,
                nameValue: nextProps.addUserProps.nameValue,
                officePhoneValue: nextProps.addUserProps.officePhoneValue,
                sexValue: nextProps.addUserProps.sexValue,
                phoneValue: nextProps.addUserProps.phoneValue,
                checkedKeys: nextProps.addUserProps.checkedKeys ? nextProps.addUserProps.checkedKeys.map(String) : "",
                propertyValue: nextProps.addUserProps.propertyValue,
                typeKey: roleShow,
                checkedKey: otherRoleShow,
                itemChildren: otherRole,
                roleValue: roleType,
                mediaRoleValue: nextProps.addUserProps.mediaRoleCodes,
                mediaRoles: nextProps.addUserProps.mediaRoles ? nextProps.addUserProps.mediaRoles : [],
                currentMediaCode: nextProps.addUserProps.mediaRoleCodes,
                itemRoleCode: nextProps.addUserProps.roleCodes,
                mediaCodesArray: nextProps.addUserProps.mediaCodes,
                managerType: nextProps.addUserProps.allMedia
            })
        }
    }

    //是否账号不可编辑
    accountDisabled = () => {
        this.setState({
            isDisabled: true,
            isHidden: true
        })
    }
    accountNotDisabled = () => {
        this.setState({
            isDisabled: false,
            isHidden: false
        })
    }

    //清除信息
    revert() {
        this.setState({
            nameValue: "",
            accountValue: "",
            typeKey: "",
            departmentValue: "",
            officePhoneValue: "",
            phoneValue: "",
            propertyValue: "",
            checkedKeys: [],
            managerType: [],
            mediaRoleValue: [],
            checkedKey: [],
            itemChildren: [],
            roleValue: 2
        });
    };

    //添加用户
    addUserOk = () => {
        let reg = /^[0-9a-zA-Z_]*$/;
        if (this.state.nameValue.length <= 0) {
            return message.info("请输入姓名");
        } else if (this.state.nameValue.length > 50) {
            return message.info("姓名长度超出限制");
        }
        if (this.state.accountValue.length <= 0) {
            message.info("请输入用户账号");
            return;
        } else if (!reg.test(this.state.accountValue)) {
            message.info("只允许输入英文字母和数字");
            return;
        }
        if (this.state.accountValue.length < 5) {
            message.info("账号至少得5个字符");
            return;
        }
        let telRegexp = new RegExp("^[0][0-9]{2,3}-[0-9]{5,10}$");
        let telRegexp_1 = new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}$");
        let telRegexp_ = new RegExp("^[1-9]{1}[0-9]{5,8}$");
        let tel = this.state.officePhoneValue;
        let phoneRegexp = new RegExp("^[1][0-9][0-9]{9}$");
        let phone = this.state.phoneValue;
        if (tel.length > 0 && !telRegexp.test(tel) && !telRegexp_.test(tel) && !phoneRegexp.test(tel) && !telRegexp_1.test(tel)) {
            message.info("办公电话格式不正确");
            return;
        }
        if (phone.length > 0 && !phoneRegexp.test(phone)) {
            message.info("手机格式不正确");
            return;
        }
        let params = {
            account: this.state.accountValue,
            name: this.state.nameValue,
            tel: this.state.officePhoneValue,
            sex: this.state.sexValue,
            phone: this.state.phoneValue,
            deptIds: this.state.checkedKeys,
            props: this.state.propertyValue,
            roleCodes: this.state.itemRoleCode,
            mediaCodes: this.state.mediaCodesArray,
            mediaRoleCodes: this.state.currentMediaCode,
        }
        if (this.state.managerType) {
            let websiteMediaIds = []
            this.state.managerType.forEach(i => {
                if (i.select) {
                    websiteMediaIds.push(i.id);
                    params.websiteMediaIds = [...websiteMediaIds]
                }
            })
            this.state.managerType.map(item => {
                if (item.select) {
                    return params[`mediaId${item.id}`] = item.select.wbaccount;
                }
            })
        }

        if (this.props.id === '') {
            Action.getAddUserData(params, (res) => {
                if (res.msg === "保存成功") {
                    message.success('添加用户成功');
                    this.props.pageChange();
                    this.props.closeModel();
                    this.revert();
                } else {
                    message.error('添加用户失败');
                }
            })
        } else {
            Action.save(params, (res) => {
                if (res.msg === "保存成功") {
                    message.success('修改用户成功');
                    this.props.closeModel();
                    this.props.pageChange();
                } else {
                    message.error('修改用户失败');
                }
            })
        }
    }


    //获得角色数据
    getRole() {
        Action.getRoleData({}, (res) => {
            let roleList = [];
            let contributeRoleList = [];
            let manageRoleList = [];
            let contributeRoleLists = [];
            let manageRoleLists = [];
            if (res && res.data) {
                roleList = res.data;
                this.state.roleList=roleList;
                this.state.roleList.forEach(item => {
                    if (item.roleType === 1) {   //按角色类型不同push进不同数组
                        contributeRoleList.push(item);
                    } else if (item.roleType === 2) {
                        manageRoleList.push(item);
                    }
                })
                //选中的是投稿端角色
                if (this.state.roleValue === 1) {
                    contributeRoleList.forEach(contributeItem => {
                        contributeRoleLists.push({
                            title: contributeItem.roleName,
                            value: contributeItem.id,
                            key: contributeItem.id,
                            roleCode: contributeItem.roleCode,
                            parentRoleCodes: contributeItem.parentRoleCodes
                        })
                    })
                }
                //选中的是管理端角色
                if (this.state.roleValue === 2) {
                    manageRoleList.forEach(manageItem => {
                        manageRoleLists.push({
                            title: manageItem.roleName,
                            value: manageItem.id,
                            key: manageItem.id,
                            roleCode: manageItem.roleCode,
                            parentRoleCodes: manageItem.parentRoleCodes
                        })
                    })
                }
                this.setState({
                    manageRoleLists,
                    contributeRoleLists,
                })
            }
        })
    }

    //关闭modal
    addUserCancel = (e) => {
        this.props.closeModel();
    };
    //性别改变
    sexChange = (e) => {
        this.setState({
            sexValue: e.target.value,
        });
    }
    //角色改变
    roleChange = (e) => {
        this.getRole();
        this.setState({
            roleValue: e.target.value,
            checkedKey: "",
            typeKey: '',
            mediaRoleValue: [],
        });
    }

    //名称改变
    nameChange(e) {
        this.setState({
            nameValue: e.target.value,
            accountValue: this.props.id === "" ? e.target.value : this.state.accountValue,
        });
    }

    //账号
    accountValue(e) {
        this.setState({
            accountValue: e.target.value,
        });
    }

    //办公电话
    officePhoneValue(e) {
        this.setState({
            officePhoneValue: e.target.value,
        });
    }

    //手机号
    phoneValue(e) {
        this.setState({
            phoneValue: e.target.value,
        });
    }

    //办公属性
    propertyValue(e) {
        this.setState({
            propertyValue: e.target.value,
        });
    }


    //媒体角色
    getMediaRole() {
        Action.getMediaRoleData({}, (res) => {
            window.loading.show();
            let allMediaRoles = [];
            let mediaRoles = [];
            if (res && res.data) {
                allMediaRoles = res.data;
                res.data.forEach(item => {
                    mediaRoles.push({label: item.name, value: item.code})
                })
                this.setState({
                    mediaRoles,
                    allMediaRoles
                })
            }
            window.loading.hide();
        })
    }

    //媒体
    getMedia(mediaCodes) {
        let params = {
            codes: mediaCodes
        }
        Action.getMediaData(params, (res) => {
            //    遍历每条数据，找到类型等于1的
            let managerType = [];
            let mediaCodesData = [];
            let resData = JSON.parse(res);
            if (resData) {
                resData.forEach(item => {
                    mediaCodesData.push({label: item.name, value: item.name})
                    if (item.type === 1) {
                        managerType.push(item);
                    }
                })
                this.state.mediaCodesData = mediaCodesData;
                if (this.props.id === "") {
                    this.setState({
                        managerType
                    })
                }
            }
        })
    }

    //媒体角色改变
    onMediaRoleChange = (value) => {
        this.state.mediaRoleValue = value;
        let mediaCodesArray = [];   //声明一个空数组
        let currentMediaCode = [];
        this.state.allMediaRoles.forEach(item => {
            let checkedFlag = false;
            this.state.mediaRoleValue.forEach(i => {
                if (item.code === i) {
                    mediaCodesArray = [...mediaCodesArray, ...item.mediaCodes]   //合并数组
                    checkedFlag = true;
                    currentMediaCode.push(item.code);   //媒体角色数据中的code
                }
            })
        })
        this.setState({
            currentMediaCode,
            mediaCodesArray
        });
        this.getMedia(mediaCodesArray);
    }


    render() {

        return (
            <div>
                <Modal
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.addUserOk}
                    onCancel={this.addUserCancel}
                    width="700px"
                    centered
                >
                    <Row>
                        <div>
                            <Col span={3}>
                                <div style={{
                                    textAlign: "right",
                                    height: "32px",
                                    marginRight: "10px",
                                    lineHeight: "32px"
                                }}>*姓名
                                </div>
                            </Col>
                            <Col span={20}>
                                <Input value={this.state.nameValue} onChange={(e) => this.nameChange(e)}
                                       placeholder="长度最长为50个字符"/>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{margin: "20px 0px"}}>
                            <Col span={3}>
                                <div style={{
                                    textAlign: "right",
                                    height: "32px",
                                    marginRight: "10px",
                                    lineHeight: "32px"
                                }}>*账号
                                </div>
                            </Col>
                            <Col span={20}>
                                <Input disabled={!!this.state.isDisabled} value={this.state.accountValue}
                                       onChange={(e) => this.accountValue(e)} placeholder="只允许输入英文字母和数字"/>
                            </Col>
                        </div>
                    </Row>
                    <Row style={{display: this.state.isHidden ? "none" : "block"}}>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{textAlign: "right", marginRight: "10px"}}>默认密码</div>
                            </Col>
                            <Col span={10}>
                                <div>z111111</div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{textAlign: "right", marginRight: "10px"}}>性别</div>
                            </Col>
                            <Col span={10}>
                                <Radio.Group onChange={this.sexChange} value={this.state.sexValue}>
                                    <Radio value={1}>男</Radio>
                                    <Radio value={2}>女</Radio>
                                </Radio.Group>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{textAlign: "right", marginRight: "10px"}}>*角色</div>
                            </Col>
                            <Col span={10}>
                                <Radio.Group defaultValue={2} onChange={this.roleChange} value={this.state.roleValue}>
                                    <Radio value={1}>投稿端角色</Radio>
                                    <Radio value={2}>管理端角色</Radio>
                                </Radio.Group>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}></Col>
                            <Col span={10}>
                                <div style={{display: "flex"}}>
                                    <div>
                                        <TreeSelect
                                            placeholder="请选择"
                                            treeCheckable={true}
                                            dropdownStyle={{height: "200px"}}
                                            showCheckedStrategy={SHOW_PARENT}
                                            style={{width: "200px"}}
                                            value={this.state.typeKey ? this.state.typeKey : undefined}
                                            treeData={this.state.roleValue === 1 ? this.state.contributeRoleLists : this.state.manageRoleLists}
                                            onChange={(value, label, extra) => {
                                                //选中每一项时拿到当前条中的roleCode字段
                                                let itemRoleCode = "";
                                                let itemChildren = [];
                                                extra.allCheckedNodes.forEach(item => {
                                                    if (item.node && item.node.props.roleCode) {
                                                        itemRoleCode = item.node.props.roleCode
                                                    }
                                                })
                                                this.state.roleList.forEach(i => {
                                                    if (i.parentRoleCodes.includes(itemRoleCode)) {
                                                        itemChildren.push({title: i.roleName, value: i.id, key: i.id})
                                                    }
                                                })
                                                this.state.typeKey = value;
                                                this.state.itemRoleCode = itemRoleCode;
                                                this.state.itemChildren = itemChildren;
                                                this.state.mediaRoleValue = [];
                                                this.setState({});
                                                this.getMediaRole();
                                            }}
                                        />
                                    </div>
                                    <div style={{
                                        marginLeft: "20px",
                                        display: this.state.checkedKey.length === 0 || this.state.typeKey.length === 0 ? "none" : "block"
                                    }}>
                                        <TreeSelect
                                            placeholder="请选择"
                                            treeCheckable={true}
                                            showCheckedStrategy={SHOW_PARENT}
                                            style={{width: "200px"}}
                                            value={this.state.checkedKey}
                                            treeData={this.state.itemChildren}
                                            onChange={(value, label, extra) => {
                                                this.state.checkedKey = value;
                                                this.setState({});
                                            }}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row style={{display: this.state.typeKey.length === 0 ? "none" : "block"}}>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{textAlign: "right", marginRight: "10px"}}>媒体角色</div>
                            </Col>
                            <Col span={21}>
                                <div>
                                    <Checkbox.Group
                                        options={this.state.mediaRoles}
                                        value={this.state.mediaRoleValue}
                                        onChange={this.onMediaRoleChange}
                                    />
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row
                        style={{display: this.state.mediaRoleValue.length === 0 || this.state.typeKey.length === 0 ? "none" : "block"}}>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3} style={{display: this.state.typeKey.length === 0 ? "none" : "block"}}>
                                <div style={{textAlign: "right", marginRight: "10px"}}>媒体</div>
                            </Col>
                            <Col span={21}>
                                <div>
                                    <Checkbox.Group
                                        disabled={true}
                                        options={this.state.mediaCodesData}   //options是字符串数组
                                        value={this.state.mediaCodesData.map(item => {
                                            return item.label;
                                        })}
                                    />
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row
                        style={{display: this.state.typeKey.length === 0 || this.state.mediaRoleValue.length === 0 ? "none" : "block"}}>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3} style={{display: this.state.mediaRoleValue.length === 0 ? "none" : "block"}}>
                                <div title={"绑定网站管理员"} style={{
                                    cursor: "pointer",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}>绑定网站管理员
                                </div>
                            </Col>
                            <Col span={21}>
                                <div style={{display: "flex", flexWrap: "wrap"}}>
                                    {this.state.managerType && this.state.managerType.map((itemManager, itemIndex) => {
                                        return (
                                            <div key={itemIndex} style={{marginLeft: "5px", marginTop: "5px"}}
                                                 onClick={() => this.singleManager(itemManager, itemIndex)}>
                                                <Tag color="#108ee9" style={{display: "flex"}}>
                                                    <div>{itemManager.name}</div>
                                                    <div
                                                        style={{display: itemManager.select ? "block" : "none"}}>(已绑定{itemManager.select && itemManager.select.wbaccount})
                                                    </div>
                                                </Tag>
                                            </div>
                                        )
                                    })}
                                    {/*管理员列表*/}
                                    {this.renderWebsiteManagerTable()}
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px", display: "flex", alignItems: "center"}}>
                            <Col span={3}>
                                <div style={{textAlign: "right", marginRight: "10px", lineHeight: "20px"}}>*部门</div>
                            </Col>
                            <Col span={21}>
                                <div style={{
                                    textAlign: "right",
                                    marginRight: "10px",
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    {
                                        this.state.deptTreeData && this.state.deptTreeData.map((items, index) => {
                                            let flag = false;
                                            this.state.checkedKeys && this.state.checkedKeys.forEach(i => {
                                                if (items.id.toString() === i) {
                                                    flag = true;   //选中
                                                }
                                            })
                                            return (
                                                <div key={index} style={{
                                                    border: '1px solid  #ebebeb',
                                                    padding: 5,
                                                    textAlign: 'center',
                                                    lineHeight: '20px',
                                                    float: 'left', marginRight: 10,
                                                    display: flag ? 'block' : 'none'
                                                }}>
                                                    {items.name}<Icon style={{cursor: 'pointer', marginLeft: "2px"}}
                                                                      onClick={(index) => {
                                                                          this.state.checkedKeys.splice(index, 1);
                                                                          this.setState({})
                                                                      }} type="close"/>
                                                </div>
                                            )
                                        })
                                    }


                                    <div style={{
                                        border: '1px solid  #ebebeb',
                                        padding: 5,
                                        textAlign: 'center',
                                        lineHeight: '20px',
                                        cursor: 'pointer',
                                        float: 'left'
                                    }}
                                         onClick={() => {
                                             this.setState({departVisible: true})
                                         }}><Icon type="plus"/>
                                    </div>
                                    {this.renderDepart()}
                                </div>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{
                                    textAlign: "right",
                                    height: "32px",
                                    marginRight: "10px",
                                    lineHeight: "32px"
                                }}>办公电话
                                </div>
                            </Col>
                            <Col span={10}>
                                <Input value={this.state.officePhoneValue} onChange={(e) => this.officePhoneValue(e)}
                                       placeholder="请输入办公电话"/>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{
                                    textAlign: "right",
                                    height: "32px",
                                    marginRight: "10px",
                                    lineHeight: "32px"
                                }}>手机
                                </div>
                            </Col>
                            <Col span={10}>
                                <Input value={this.state.phoneValue} onChange={(e) => this.phoneValue(e)}
                                       placeholder="请输入手机"/>
                            </Col>
                        </div>
                    </Row>
                    <Row>
                        <div style={{marginTop: "20px"}}>
                            <Col span={3}>
                                <div style={{
                                    textAlign: "right",
                                    height: "32px",
                                    marginRight: "10px",
                                    lineHeight: "32px"
                                }}>属性
                                </div>
                            </Col>
                            <Col span={10}>
                                <Input value={this.state.propertyValue} onChange={(e) => this.propertyValue(e)}
                                       placeholder="请输入用户属性"/>
                            </Col>
                        </div>
                    </Row>
                </Modal>
            </div>
        );
    }

    //渲染部门弹出框
    renderDepart() {
        return (
            <Modal
                title={'设置部门'}
                visible={this.state.departVisible}
                onOk={() => {
                    this.setState({departVisible: false});
                }}
                onCancel={() => {
                    this.setState({departVisible: false});
                }}
                width={400}
                centered
            >
                <div style={{width: 350, height: 250, overflowY: 'auto'}}>
                    <Scrollbars>
                        {this.state.deptTreeData.length > 0 ? (
                            <Tree
                                checkable
                                defaultExpandAll
                                onCheck={
                                    (checkedKeys, e) => {
                                        this.setState({
                                            checkedKeys: checkedKeys.checked,    //父子节点不再关联
                                        });
                                    }
                                }
                                checkStrictly
                                checkedKeys={this.state.checkedKeys}
                            >
                                {this.props.renderTreeNodes()}
                            </Tree>
                        ) : null}
                    </Scrollbars>
                </div>

            </Modal>

        )
    }

    //    绑定网站管理员
    singleManager(item, itemIndex) {
        let params = {
            size: this.state.managerSize,
            start: this.state.managerStart,
            mediaId: item.id
        }
        Action.getWebsiteManagerData(params, (res) => {
            let managerList = [];
            let listTotal = 0;
            if (res && res.data) {
                managerList = res.data;
                listTotal = res.count;
            }
            this.setState({
                managerList,
                managerItemId: item,
                managerItemName: item.name,
                websiteManagerVisible: true,
                listTotal: listTotal,
                itemIndex
            })
        })
    }

    //渲染网站管理员列表
    renderWebsiteManagerTable() {
        const ManagerRowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
            },
            onSelect: (record, selected, selectedRows) => {
                this.state.managerType[this.state.itemIndex].select = record;  //每条数据添加selected属性绑定选中的item
                this.setState({
                    selectedRecord: record
                })
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
            },
            type: "radio"
        }
        return (
            <Modal
                title={`绑定${this.state.managerItemName}网站管理员`}
                visible={this.state.websiteManagerVisible}
                onOk={() => {
                    this.setState({websiteManagerVisible: false});
                }}
                onCancel={() => {
                    this.setState({websiteManagerVisible: false});
                }}
                bodyStyle={{height: "500px"}}
                centered
            >
                <div style={{padding: "10px", height: "430px"}}>
                    <Scrollbars>
                        <Table rowKey={record => record.id} pagination={false} rowSelection={ManagerRowSelection}
                               dataSource={this.state.managerList} columns={this.managerColumns}/>
                    </Scrollbars>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        margin: "10px 10px 10px 0px"
                    }}
                >
                    <Pagination
                        showQuickJumper
                        size={"small"}
                        current={this.state.managerStart}
                        pageSize={this.state.managerSize}
                        total={this.state.listTotal}
                        showTotal={(total) => `共 ${total} 条`}
                        showSizeChanger
                        onChange={(page, pageSize) =>
                            this.onManagerChange(page, pageSize)
                        }
                        onShowSizeChange={(page, pageSize) => {
                            this.onManagerChange(page, pageSize);
                        }}
                    />
                </div>
            </Modal>
        )
    }

    // 页面改变时回调
    onManagerChange(page, pageSize) {
        this.state.managerStart = page;
        this.state.managerSize = pageSize;
        this.singleManager(this.state.managerItemId);
    }

    managerColumns = [
        {
            key: "1",
            title: "姓名",
            dataIndex: "name",
            width: "15%",
            ellipsis: true,
            align: "center",
            textWrap: "word-break",
            render: (value, row, index) => {
                return (
                    <div style={{
                        cursor: "pointer",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineClamp: 1,
                        whiteSpace: "nowrap"
                    }}>{row.wbname}</div>
                )
            }
        },
        {
            key: "2",
            title: "账号",
            dataIndex: "account",
            width: "15%",
            ellipsis: true,
            align: "center",
            textWrap: "word-break",
            render: (value, row, index) => {
                return (
                    <div>{row.wbaccount}</div>
                )
            }
        },
    ]


}

export default AddUser;